import { LS } from '@mx/util/local-storage';
import { getCookie } from '@mx/util/get-cookie';
import { removeCookie } from '@mx/util/remove-cookie';
import { bridge } from './bridge';
import { Runtime } from './constant';
/**
 * 获取数据存储
 * 1. 获取KNB.getStorage 数据
 * 2. 如未获取到则取值 LS
 * 3. 1、2都未获取到则取值 cookie
 * @param key
 * @returns
 */
export function getStorage(key: string) {
  return new Promise((resolve, reject) => {
    bridge
      .getStorage(key)
      .then((res: any) => {
        if (!res.value) {
          throw new Error(`getStorage key: ${key}未取到`);
        }
        resolve(res.value);
      })
      .catch((error: Error) => {
        const result = LS.get(key) || getCookie(key);
        if (result) {
          resolve(result);
        } else {
          reject(error);
        }
      });
  });
}

export function removeStorage(key: string) {
  bridge.clearStorage(key);
  LS.remove(key);
  removeCookie(key);
}

export function getRuntime(): Runtime {
  const host = window.location.host;
  if (/\.dev\.sankuai\.com/.test(host)) {
    return Runtime.Dev;
  } else if (/\.test\.sankuai\.com/.test(host)) {
    return Runtime.Test;
  } else if (/\.st\.(sankuai|meituan)\.com/.test(host)) {
    return Runtime.Staging;
  } else if (/\.meituan\.com/.test(host)) {
    return Runtime.Prod;
  } else {
    return Runtime.Local;
  }
}

const funCount: Record<string, 1> = {};
export function onceInTime(fn: () => void, time: number) {
  const funName = fn.name;
  return function (...args: Array<unknown>) {
    if (Object.prototype.hasOwnProperty.call(funCount, funName)) {
      return;
    }
    funCount[funName] = 1;
    // @ts-ignore
    fn(...args);
    const timeId = setTimeout(() => {
      clearTimeout(timeId);
      delete funCount[funName];
    }, time);
  };
}
export function parseData(data: any): Promise<Record<string, any>> {
  return new Promise((resolve, reject) => {
    let parseInfo = {};
    if (typeof data === 'string') {
      try {
        parseInfo = JSON.parse(data);
      } catch (error) {
        reject(error);
      }
    } else {
      parseInfo = data;
    }
    resolve(parseInfo);
  });
}
export function getDeductionOrderPageUrl(mtPlanId: number | string) {
  const link = `${window.location.origin}/resource/pay-deduction-part/deduction-order.html?mtPlanId=${mtPlanId}&pageStyle=page&hideEntry=1`;
  bridge.openPage(link);
}
